import React, {Component} from "react";
import {APIClient} from "../../utils/APIClient";
import {API_URL} from "../../settings/local_settings";
import {ClientHeader} from "./ClientHeader";
import {ClientTabs} from "./ClientTabs";
import {ClientInfo} from "./ClientInfo";
import {ClientBusinessContext} from "./ClientBusinessContext";
import {ClientIntegrationsInfo} from "./ClientIntegrationsInfo";
import {ClientDangerZone} from "./ClientDangerZone";


export class ClientConfigurationContent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            name: '',
            loading: false,
            isSaving: false
        };
    }

    componentDidMount() {
        this.getClientIntegrationsData();
        this.updateClientData();
    }

    setIsLoading(new_value){
        this.setState({
            ...this.state,
            loading: new_value
        });
    }

    setIsSaving(new_value){
        this.setState({
            ...this.state,
            isSaving: new_value
        });
    }

    getClientIntegrationsData() {
        this.setIsLoading(true);

        new APIClient(this.getClientIntegrationsDataURL()).call('GET').then((data) => {
            this.setIsLoading(false);
            if (data.status === 'ERROR') {
                alert(data['error_message']);
            } else if (data.status === 'OK') {
                this.setState({
                    name: data.data["name"]
                });
            }
        })
    }

    getClientIntegrationsDataURL() {
        return API_URL + 'client/' + this.props.clientId+'/integrations-data';
    }

    updateClientData() {
        this.setIsSaving(true);
        new APIClient(this.updateClientDataURL()).call('GET').then((data) => {
            this.setIsSaving(false);
            if (data.status === 'ERROR') {
                alert(data['error_message']);
            } else if (data.status === 'OK') {
                this.setState(
                    {
                        name: data.data['name']
                    });
            }
        })
    }

    updateClientDataURL() {
        return API_URL + 'client/' + this.props.clientId;
    }

    render() {
        return (
            <section className="section-content">
                <ClientHeader name={this.state.name}/>
                <ClientTabs clientId={this.props.clientId}/>

                <div className="section-body h-items client-config-top">
                    <ClientInfo clientId={this.props.clientId}/>
                    <ClientBusinessContext clientId={this.props.clientId}/>
                    <ClientIntegrationsInfo clientId={this.props.clientId}/>
                </div>

                <div className="section-body client-config-danger-section">
                    <div className="client-config-danger">
                        <ClientDangerZone clientId={this.props.clientId} navigate={this.props.navigate}/>
                    </div>
                </div>

            </section>
        )
    }
}
